import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/backdoor-roth-calculator',
  component: () => import('../../routes/BackdoorRoth.svelte'),
  card: {
    id: 'backdoor-roth',
    title: 'Backdoor Roth IRA',
    description: 'Calculate the tax advantage of a Backdoor Roth IRA strategy vs. a taxable brokerage account.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/backdoor-roth-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Backdoor Roth IRA Calculator – Tax-Free Growth Strategy',
    description: 'Compare a Backdoor Roth IRA contribution vs. investing the same after-tax amount in a taxable brokerage account. See the long-term tax-free growth advantage of the Roth strategy.',
  },
};

export default meta;